import { useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";

interface UrlQuery<T> {
  urlParams: (key: keyof T) => string | null;
}

const useQueryParams = <T>(): UrlQuery<T> => {
  const location = useLocation();
  const search = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const urlParams = useCallback(
    (key: keyof T) => search.get(key as string),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [search]
  );

  return { urlParams };
};

export default useQueryParams;
